import { render, staticRenderFns } from "./ManageUnsubscription.vue?vue&type=template&id=dc617aba&scoped=true&"
import script from "./ManageUnsubscription.vue?vue&type=script&lang=js&"
export * from "./ManageUnsubscription.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=dc617aba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc617aba",
  null
  
)

export default component.exports